import React, { useState, useEffect } from 'react';
import i18n from 'i18n-js';
import { Alert, Button, Checkbox, Modal, Space } from '@duxton-web/ui';

interface TransactionalTemplateAckModalProps {
  open: boolean;
  templateName: string;
  onConfirm: () => void;
  onCancel: () => void; // Cancel button AND close icon/mask/Esc
}

const TransactionalTemplateAckModal = ({
  open,
  templateName,
  onConfirm,
  onCancel,
}: TransactionalTemplateAckModalProps) => {
  const [bypassChecksAcked, setBypassChecksAcked] = useState(false);
  const [privacyBreachAcked, setPrivacyBreachAcked] = useState(false);
  const [acceptAcked, setAcceptAcked] = useState(false);

  useEffect(() => {
    if (open) {
      setBypassChecksAcked(false);
      setPrivacyBreachAcked(false);
      setAcceptAcked(false);
    }
  }, [open]);

  const allChecked = bypassChecksAcked && privacyBreachAcked && acceptAcked;

  return (
    <Modal
      title={i18n.t('trident_campaign.transactional_template_ack.title')}
      open={open}
      onCancel={onCancel}
      destroyOnClose
      zIndex={1100}
      footer={
        <Space style={{ justifyContent: 'flex-end' }}>
          <Button onClick={onCancel}>
            {i18n.t('trident_campaign.transactional_template_ack.cancel')}
          </Button>
          <Button type="primary" disabled={!allChecked} onClick={onConfirm}>
            {i18n.t('trident_campaign.transactional_template_ack.confirm')}
          </Button>
        </Space>
      }
    >
      <p>
        {i18n.t('trident_campaign.transactional_template_ack.intro')}
        {' '}
        {templateName}
      </p>
      <Alert
        type="error"
        showIcon
        style={{ backgroundColor: '#fcbfbf' }}
        message={(
          <Space direction="vertical">
            <Checkbox
              checked={bypassChecksAcked}
              onChange={(event) => setBypassChecksAcked(event.target.checked)}
            >
              {i18n.t('trident_campaign.transactional_template_ack.bypass_checks')}
            </Checkbox>
            <Checkbox
              checked={privacyBreachAcked}
              onChange={(event) => setPrivacyBreachAcked(event.target.checked)}
            >
              {i18n.t('trident_campaign.transactional_template_ack.privacy_breach')}
            </Checkbox>
            <Checkbox
              checked={acceptAcked}
              onChange={(event) => setAcceptAcked(event.target.checked)}
            >
              {i18n.t('trident_campaign.transactional_template_ack.accept')}
            </Checkbox>
          </Space>
        )}
      />
    </Modal>
  );
};

export default TransactionalTemplateAckModal;
